import { Component, OnInit } from '@angular/core';
import { alertController } from '@ionic/core';

import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { CredentialsService } from "src/app/services/credentials/credentials.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { UserService } from "src/app/services/user/user.service";
import { environment } from "src/environments/environment";
import { StorageService } from "src/app/services/storage/storage.service";

@Component({
  selector: 'app-nequi',
  templateUrl: './nequi.page.html',
  styleUrls: ['./nequi.page.scss'],
})
export class NequiPage implements OnInit {

  token: any;
  dataLocalS: any;
  dataCredentials: {};
  dataPrograms: any;
  programIdFWC: any;
  companyIdFWC: any;
  dataUser: any;
  phoneUserWC: any;
  re = /[+]57/;
  baseUrl: any;
  phone: any;
  username: any;

constructor(
  public languageService: LanguagesService,
  public credentialsService: CredentialsService,
  public authService: AuthService,
  public userService: UserService,
  public storage: StorageService
) { }

async getToken(){
  this.token = await this.storage.get("gnx-token");
  console.log('token ==', this.token);
}

async getDataLocalS(){
  this.dataLocalS = await this.storage.get("gnx-claims");
  console.log('dataLocalS ==', this.dataLocalS);
  this.phone = this.dataLocalS.phone;
  this.username = this.dataLocalS.username;
  this.dataPrograms = this.dataLocalS.programs[0].split("/");
  this.companyIdFWC = this.dataPrograms[1];
  this.programIdFWC = this.dataPrograms[3];
}

ngOnInit() {
  this.getCredentials();
  this.getToken();
  this.getDataLocalS();
  this.getDataUser();
}

get getTextIUNequi() {
  return this.languageService.textsIU.page_nequi;
}

getCredentials = () => {
  this.credentialsService.registerChat();
  this.dataCredentials = this.credentialsService.registerChat();
  this.baseUrl = environment.gluky.ordersApiBasePatch;
};

async getDataUser() {

  let dataU: any = {};
  this.userService.getUserInfo().subscribe(
  (basicUserInfo: any) => {
  dataU.email = 'username@nomail.glukynet.com';
  dataU.phone = this.phone.replace(this.re,'');
  dataU.name = basicUserInfo.name;
  dataU.document = this.username;
  dataU.lastName = basicUserInfo.lastnames;
  dataU.dateBorn = basicUserInfo.dateBorn;
  dataU.docNumber = this.username;

  this.phoneUserWC = dataU.phone;
    },

    async (err) => {
    console.log(err);
    }
  ); 
  this.dataUser = dataU;
  //console.log('DATA USER', dataU);
}

async alert ($event) {
  const header = $event.detail.header;
  const subHeader = $event.detail.subHeader;
  const message = $event.detail.message;

  console.log('event',typeof message);
  const alert = await alertController.create({
    cssClass: 'my-custom-class',
    header: header,
    subHeader: subHeader,
    message: message,
    buttons: ['OK']
  }); 
  alert.present();
  }
}
